/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class RSVPSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-13-et z-22 p-40">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <h1 className="f-62 brand-text bold-text text-uppercase">Take the<br/><span className="f-100-long ls-5 white-text">Next Step:</span> </h1>
                            </div>
                        </div>
                        <div className="row mb0 p-40 ">
                            <div className="col s12 center-align">
                                <h1 className="f-62 white-text text-uppercase">RSVP IF YOU WANT<br/><span className="f-100-long ls-5 white-text bold-text">To Take <span className="f-100-long ls-5 brand-text bold-text">OWN</span>ership</span> </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 center-align">
                                <h1 className="f-32 white-text text-uppercase text-normal">Our Next Mastermind Is On<br/><span className="bold-text white-text">December 9th & 10th</span></h1>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <h1 className="f-32 white-text text-uppercase text-normal">The location of the Mastermind is<br/><span className="bold-text white-text">Newark NJ</span></h1>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 center-align">
                               <CTA/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default RSVPSection;


// WEBPACK FOOTER //
// ./src/components/rsvp-section.js